"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verify = exports.sign = exports.generateKeyPair = void 0;
const nacl = require("tweetnacl");
const buffer_1 = require("buffer");
function generateKeyPair(hash) {
    const uint = Uint8Array.from(hash);
    const keypair = nacl.sign.keyPair.fromSeed(uint);
    const bufferKeyPair = {
        privateKey: buffer_1.Buffer.from(keypair.secretKey),
        publicKey: buffer_1.Buffer.from(keypair.publicKey),
    };
    return bufferKeyPair;
}
exports.generateKeyPair = generateKeyPair;
function sign(hash, secretKey) {
    const uintHash = Uint8Array.from(hash);
    const uintSecretKey = Uint8Array.from(secretKey);
    const signature = nacl.sign.detached(uintHash, uintSecretKey);
    return buffer_1.Buffer.from(signature);
}
exports.sign = sign;
function verify(hash, signature, publicKey) {
    const uintHash = Uint8Array.from(hash);
    const uintSignature = Uint8Array.from(signature);
    const uintPublicKey = Uint8Array.from(publicKey);
    const res = nacl.sign.detached.verify(uintHash, uintSignature, uintPublicKey);
    return res;
}
exports.verify = verify;
//# sourceMappingURL=index.js.map